import { combineReducers } from '@reduxjs/toolkit';
import optionsReducer from './Slices/Options';
import gameReducer from './Slices/Game';
import navigationReducer from './Slices/Navigation';

const rootReducer = combineReducers({
  options: optionsReducer,
  game: gameReducer,
  navigation: navigationReducer,
});

export default rootReducer;
